/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { asyncConnect } from 'ha/modules/ReduxConnect';
import { loadHermesData } from 'ha/modules/Hermes';
import { getFavoriteListings } from 'ha/modules/FavoriteListing';
import collectionToFilters from 'ha/utils/filters/collectionToFilters';
import { Experiment, Variant } from 'ha/modules/Experiments';
import EXPERIMENTS from 'ha/constants/experiments';
import { getFeatureFlags } from 'ha/modules/FeatureFlags';

import reportError from 'ha/helpers/bugsnag/reportError';

import getSearchAlert from '../actions/getSearchAlert';
import { load, getCollectionStats, loadAdvertiser } from '../actions';
import {
  getPageName,
  getAnalyticsForListings,
  getErrorState,
  getCityCanonical,
  getCountryCode,
  isNotFound,
  isUnsupportedCountry,
} from '../selectors';
import { STATE_NAME } from '../constants';

import SearchRoot from '../components/SearchRoot';

const searchPromise = ({
  params,
  location: { pathname, query, action },
  store: { dispatch },
}) => {
  const localizedKind = params.localizedKind
    ? encodeURIComponent(params.localizedKind)
    : undefined;
  // Prevent calling Algolia when map query params are modified on the URL,
  // since the map is decuple from the listings.
  if (action === 'REPLACE') {
    return Promise.resolve();
  }

  return dispatch(getCollectionStats(localizedKind, params.location)).then(
    stats =>
      Promise.all([
        dispatch(
          load({
            ...collectionToFilters(localizedKind, stats),
            ...params,
            ...query,
            localizedKind,
            priceAverage: stats.averagePrice,
          }),
        ),
        dispatch(loadHermesData(pathname)),
        dispatch(getFavoriteListings()),
        query.userId
          ? dispatch(loadAdvertiser(query.userId))
          : Promise.resolve(),
      ]).catch(error => {
        reportError('Search Page Load Error', {
          metaData: { error, params, pathname, query, stats },
        });
      }),
  );
};

const mapStateToProps = state => ({
  cityCanonical: getCityCanonical(state),
  countryCode: getCountryCode(state),
  error: getErrorState(state),
  pageName: getPageName(state),
  listingsAnalytics: getAnalyticsForListings(state),
  notFound: isNotFound(state),
  isUnsupportedCountry: isUnsupportedCountry(state),
  featureFlags: getFeatureFlags(state),
});

const mapDispatchToProps = {
  getSearchAlert,
};

const enhance = asyncConnect(
  [{ key: STATE_NAME, promise: searchPromise }],
  mapStateToProps,
  mapDispatchToProps,
);

const SearchRootWithExperiment = props => (
  <React.Fragment>
    {/* We need to add the Experiment Element in order to register in Analytics */}
    {props.featureFlags.searchNewDateLogicExp === 'on' && (
      <Experiment name={EXPERIMENTS.HA8438.name}>
        <Variant name="A" />
        <Variant name="B" />
      </Experiment>
    )}

    <SearchRoot {...props} />
  </React.Fragment>
);

export default enhance(SearchRootWithExperiment);
